export enum BenefitAlertSource {
  InvoicePreview = 'Invoice Preview',
  MessageComposer = 'Message Composer',
  InvoicingPanel = 'Invoicing Panel',
}
